// Author : Vishnu
// Version : 0.0.1
// MODIFIED DATE: 21/08/2025
const BalanceSheetType = {
	/*********  GET PROFIT LOSS REPORT  - START  *********/
	GET_PROFIT_LOSS_REPORT_START: 'get_profit_loss_report_start',
	GET_PROFIT_LOSS_REPORT_SUCCESS: 'get_profit_loss_report_success',
	GET_PROFIT_LOSS_REPORT_FAILURE: 'get_profit_loss_report_failure',
	GET_PROFIT_LOSS_REPORT_RESPONSE_RESET: 'get_profit_loss_report_response_reset',
	GET_PROFIT_LOSS_REPORT_RESPONSE_CHANGED: 'get_profit_loss_report_response_changed',
	/*********  GET PROFIT LOSS REPORT - END  *********/

	/********* GET BALANCE SHEET REPORT - START  *********/
	GET_BALANCE_SHEET_REPORT_START: 'get_balance_sheet_report_start',
	GET_BALANCE_SHEET_REPORT_SUCCESS: 'get_balance_sheet_report_success',
	GET_BALANCE_SHEET_REPORT_FAILURE: 'get_balance_sheet_report_failure',
	GET_BALANCE_SHEET_REPORT_RESPONSE_RESET: 'get_balance_sheet_report_response_reset',
	GET_BALANCE_SHEET_REPORT_RESPONSE_CHANGED: 'get_balance_sheet_report_response_changed',
	/********* GET BALANCE SHEET REPORT - END  *********/
};
export default BalanceSheetType;
